import { DropDownOption } from '@product/shared/models/GlobalInterfaces';

export enum AttributeTypes {
  Number = 0,
  String,
  Date,
  Time,
  Text,
  Html,
  Select,
  MultiSelect,
  Object,
  Picture,
  Video,
  MediaGallery,
  Boolean,
}

export const AttributeTypesValidValues = [
  {
    Code: AttributeTypes.Number,
    Name: 'Number',
    Icon: 'input-numeric',
  },
  {
    Code: AttributeTypes.String,
    Name: 'String',
    Icon: 'input-text',
  },
  {
    Code: AttributeTypes.Date,
    Name: 'Date',
    Icon: 'calendar-days',
  },
  {
    Code: AttributeTypes.Time,
    Name: 'Time',
    Icon: 'timer',
  },
  {
    Code: AttributeTypes.Text,
    Name: 'Multiple Line Text',
    Icon: 'message-text',
  },
  {
    Code: AttributeTypes.Html,
    Name: 'Html',
    Icon: 'code',
  },
  {
    Code: AttributeTypes.Select,
    Name: 'Dropdown List',
    Icon: 'list-dropdown',
  },
  {
    Code: AttributeTypes.MultiSelect,
    Name: 'Multiple Select',
    Icon: 'list-check',
  },
  {
    Code: AttributeTypes.Object,
    Name: 'Object',
    Icon: 'diagram-project',
  },
  {
    Code: AttributeTypes.Picture,
    Name: 'Picture',
    Icon: 'image',
  },
  {
    Code: AttributeTypes.Video,
    Name: 'Video',
    Icon: 'video',
  },
  {
    Code: AttributeTypes.MediaGallery,
    Name: 'Media Gallery',
    Icon: 'gallery-thumbnails',
  },
  {
    Code: AttributeTypes.Boolean,
    Name: 'Boolean',
    Icon: 'toggle-on',
  },
];

export const ScopeValidValues = [
  {
    Code: '1',
    Name: 'Language',
  },
  {
    Code: '2',
    Name: 'Global',
  },
];

export const YesNoValidValues = [
  {
    Code: true,
    Name: 'Yes',
  },
  {
    Code: false,
    Name: 'No',
  },
];
//new 
export const UseInLayeredNavigationValidValues = [
  {
    
    Name: 'No',
    Code: 'No',
  },
  {
 
    Name: 'Yes with results only',
    Code: 'YesWithResultsOnly',
  },
  {
    
    Name: 'Yes includes no results',
    Code: 'YesIncludesNoResults',
  },
];


export const Entities = [
  // {
  //   Name: 'Brand',
  //   Code: 5,
  // },
  {
    Name: 'Category',
    Code: 6,
  },
  // {
  //   Name: 'Collection',
  //   Code: 7,
  // },
  // {
  //   Name: 'Currency',
  //   Code: 10,
  // },
  // {
  //   Name: 'Manufacturer',
  //   Code: 11,
  // },
  {
    Name: 'Product',
    Code: 12,
  },
  {
    Name: 'Tag',
    Code: 13,
  },
  {
    Name: 'Attribute',
    Code: 1,
  },
];

export function HardCopy(obj: any) {
  if (obj == null) {
    return null;
  } else {
    return JSON.parse(JSON.stringify(obj));
  }
}

export const languages: DropDownOption[] = [
  { Label: 'Afrikaans', Code: 'af' },
  { Label: 'Albanian', Code: 'sq' },
  { Label: 'Arabic (Algeria)', Code: 'ar-dz' },
  { Label: 'Arabic (Bahrain)', Code: 'ar-bh' },
  { Label: 'Arabic (Egypt)', Code: 'ar-eg' },
  { Label: 'Arabic (Iraq)', Code: 'ar-iq' },
  { Label: 'Arabic (Jordan)', Code: 'ar-jo' },
  { Label: 'Arabic (Kuwait)', Code: 'ar-kw' },
  { Label: 'Arabic (Lebanon)', Code: 'ar-lb' },
  { Label: 'Arabic (Libya)', Code: 'ar-ly' },
  { Label: 'Arabic (Morocco)', Code: 'ar-ma' },
  { Label: 'Arabic (Oman)', Code: 'ar-om' },
  { Label: 'Arabic (Qatar)', Code: 'ar-qa' },
  { Label: 'Arabic (Saudi Arabia)', Code: 'ar-sa' },
  { Label: 'Arabic (Syria)', Code: 'ar-sy' },
  { Label: 'Arabic (Tunisia)', Code: 'ar-tn' },
  { Label: 'Arabic (U.A.', Code: 'E.)ar-ae' },
  { Label: 'Arabic (Yemen)', Code: 'ar-ye' },
  { Label: 'Basque', Code: 'eu' },
  { Label: 'Belarusian', Code: 'be' },
  { Label: 'Bulgarian', Code: 'bg' },
  { Label: 'Catalan', Code: 'ca' },
  { Label: 'Chinese (Hong Kong)', Code: 'zh-hk' },
  { Label: 'Chinese (PRC)', Code: 'zh-cn' },
  { Label: 'Chinese (Singapore)', Code: 'zh-sg' },
  { Label: 'Chinese (Taiwan)', Code: 'zh-tw' },
  { Label: 'Croatian', Code: 'hr' },
  { Label: 'Czech', Code: 'cs' },
  { Label: 'Danish', Code: 'da' },
  { Label: 'Dutch (Belgium)', Code: 'nl-be' },
  { Label: 'Dutch (Standard)', Code: 'nl' },
  { Label: 'English', Code: 'en' },
  { Label: 'English (Australia)', Code: 'en-au' },
  { Label: 'English (Belize)', Code: 'en-bz' },
  { Label: 'English (Canada)', Code: 'en-ca' },
  { Label: 'English (Ireland)', Code: 'en-ie' },
  { Label: 'English (Jamaica)', Code: 'en-jm' },
  { Label: 'English (New Zealand)', Code: 'en-nz' },
  { Label: 'English (South Africa)', Code: 'en-za' },
  { Label: 'English (Trinidad)', Code: 'en-tt' },
  { Label: 'English (United Kingdom)', Code: 'en-gb' },
  { Label: 'English (United States)', Code: 'en-us' },
  { Label: 'Estonian', Code: 'et' },
  { Label: 'Faeroese', Code: 'fo' },
  { Label: 'Farsi', Code: 'fa' },
  { Label: 'Finnish', Code: 'fi' },
  { Label: 'French (Belgium)', Code: 'fr-be' },
  { Label: 'French (Canada)', Code: 'fr-ca' },
  { Label: 'French (Luxembourg)', Code: 'fr-lu' },
  { Label: 'French (Standard)', Code: 'fr' },
  { Label: 'French (Switzerland)', Code: 'fr-ch' },
  { Label: 'Gaelic (Scotland)', Code: 'gd' },
  { Label: 'German (Austria)', Code: 'de-at' },
  { Label: 'German (Liechtenstein)', Code: 'de-li' },
  { Label: 'German (Luxembourg)', Code: 'de-lu' },
  { Label: 'German (Standard)', Code: 'de' },
  { Label: 'German (Switzerland)', Code: 'de-ch' },
  { Label: 'Greek', Code: 'el' },
  { Label: 'Hebrew', Code: 'he' },
  { Label: 'Hindi', Code: 'hi' },
  { Label: 'Hungarian', Code: 'hu' },
  { Label: 'Icelandic', Code: 'is' },
  { Label: 'Indonesian', Code: 'id' },
  { Label: 'Irish', Code: 'ga' },
  { Label: 'Italian (Standard)', Code: 'it' },
  { Label: 'Italian (Switzerland)', Code: 'it-ch' },
  { Label: 'Japanese', Code: 'ja' },
  { Label: 'Korean', Code: 'ko' },
  { Label: 'Korean (Johab)', Code: 'ko' },
  { Label: 'Kurdish', Code: 'ku' },
  { Label: 'Latvian', Code: 'lv' },
  { Label: 'Lithuanian', Code: 'lt' },
  { Label: 'Macedonian (FYROM)', Code: 'mk' },
  { Label: 'Malayalam', Code: 'ml' },
  { Label: 'Malaysian', Code: 'ms' },
  { Label: 'Maltese', Code: 'mt' },
  { Label: 'Norwegian', Code: 'no' },
  { Label: 'Norwegian (Bokmål)', Code: 'nb' },
  { Label: 'Norwegian (Nynorsk)', Code: 'nn' },
  { Label: 'Polish', Code: 'pl' },
  { Label: 'Portuguese (Brazil)', Code: 'pt-br' },
  { Label: 'Portuguese (Portugal)', Code: 'pt' },
  { Label: 'Punjabi', Code: 'pa' },
  { Label: 'Rhaeto', Code: '-Romanicrm' },
  { Label: 'Romanian', Code: 'ro' },
  { Label: 'Romanian (Republic of ', Code: 'Moldova)ro-md' },
  { Label: 'Russian', Code: 'ru' },
  { Label: 'Russian (Republic of ', Code: 'Moldova)ru-md' },
  { Label: 'Serbian', Code: 'sr' },
  { Label: 'Slovak', Code: 'sk' },
  { Label: 'Slovenian', Code: 'sl' },
  { Label: 'Sorbian', Code: 'sb' },
  { Label: 'Spanish (Argentina)', Code: 'es-ar' },
  { Label: 'Spanish (Bolivia)', Code: 'es-bo' },
  { Label: 'Spanish (Chile)', Code: 'es-cl' },
  { Label: 'Spanish (Colombia)', Code: 'es-co' },
  { Label: 'Spanish (Costa Rica)', Code: 'es-cr' },
  { Label: 'Spanish (Dominican Republic)', Code: 'es-do' },
  { Label: 'Spanish (Ecuador)', Code: 'es-ec' },
  { Label: 'Spanish (El Salvador)', Code: 'es-sv' },
  { Label: 'Spanish (Guatemala)', Code: 'es-gt' },
  { Label: 'Spanish (Honduras)', Code: 'es-hn' },
  { Label: 'Spanish (Mexico)', Code: 'es-mx' },
  { Label: 'Spanish (Nicaragua)', Code: 'es-ni' },
  { Label: 'Spanish (Panama)', Code: 'es-pa' },
  { Label: 'Spanish (Paraguay)', Code: 'es-py' },
  { Label: 'Spanish (Peru)', Code: 'es-pe' },
  { Label: 'Spanish (Puerto Rico)', Code: 'es-pr' },
  { Label: 'Spanish (Spain)', Code: 'es' },
  { Label: 'Spanish (Uruguay)', Code: 'es-uy' },
  { Label: 'Spanish (Venezuela)', Code: 'es-ve' },
  { Label: 'Swedish', Code: 'sv' },
  { Label: 'Swedish (Finland)', Code: 'sv-fi' },
  { Label: 'Thai', Code: 'th' },
  { Label: 'Tsonga', Code: 'ts' },
  { Label: 'Tswana', Code: 'tn' },
  { Label: 'Turkish', Code: 'tr' },
  { Label: 'Ukrainian', Code: 'ua' },
  { Label: 'Urdu', Code: 'ur' },
  { Label: 'Venda', Code: 've' },
  { Label: 'Vietnamese', Code: 'vi' },
  { Label: 'Welsh', Code: 'cy' },
  { Label: 'Xhosa', Code: 'xh' },
  { Label: 'Yiddish', Code: 'ji' },
  { Label: 'Zulu', Code: 'zu' },
];
